import React from 'react';
import { Link } from 'react-router-dom';
import { Coins, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <Coins className="w-8 h-8 text-primary-400" />
              <span className="text-xl font-bold">O Teu Dinheiro</span>
            </div>
            <p className="text-gray-300">
              Educação financeira simples e prática para o brasileiro
            </p>
          </div>

          {/* Educação Financeira */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Educação Financeira</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/dividas" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Gerenciar Dívidas
                </Link>
              </li>
              <li>
                <Link to="/economia" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Dicas de Economia
                </Link>
              </li>
              <li>
                <Link to="/investimentos" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Investimentos
                </Link>
              </li>
            </ul>
          </div>

          {/* Recursos */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Recursos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/pix" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Entender PIX
                </Link>
              </li>
              <li>
                <Link to="/calculadoras" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Calculadoras
                </Link>
              </li>
              <li>
                <Link to="/planilhas" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Planilhas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contato</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-gray-300">
                <Mail className="w-4 h-4" />
                <a 
                  href="mailto:contato@oteudinheiro.com.br"
                  className="hover:text-primary-400 transition-colors"
                >
                  contato@oteudinheiro.com.br
                </a>
              </div>
              <p className="text-gray-300 text-sm">
                Dúvidas? Entre em contato conosco!
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              &copy; 2025 O Teu Dinheiro. Todos os direitos reservados.
            </p>
            <p className="text-gray-400 text-sm text-center md:text-left">
              Este site é apenas informativo. Consulte um profissional para orientações específicas.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
